import DotLegalDeleteDialogWrapper from "@common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import { DeleteRiskScenarioDialogDataMapping } from "./DeleteRiskScenarioDialog.hooks";
import { RiskScenarioViewModel } from "../RiskScenarios.types";

export interface IDeleteRiskScenarioDialog {
    onCloseDialog: () => void;
    onDeletion: () => void;
    selectedRiskScenario: RiskScenarioViewModel;
}

export function DeleteRiskScenarioDialog(props: IDeleteRiskScenarioDialog) {
    const { removeRiskScenario, inProgress } = DeleteRiskScenarioDialogDataMapping(props);

    return (
        <DotLegalDeleteDialogWrapper
            open
            itemForDeletion={props.selectedRiskScenario.name}
            onDialogClose={props.onCloseDialog}
            onOkClick={removeRiskScenario}
            inProgress={inProgress}
        />
    );
}
